export const FROM_MAIN_REGEXP = {
  production: /marpple\.shop/,
  staging: /marpple\.(cc|tw)/,
  development: /(:9077|:9078|:9079|:11001|:11002|:11003)/,
};
